module.exports = __webpack_public_path__ + "media/components/assets/icons/sidebar_payment-b84c3c88127b796d0b0a4c4b075d9e5a.svg";